import Jwt from '../services/Jwt';
import Swal from 'sweetalert2';
import imageAlert from "@/assets/images/error.svg"

let myAlert;

/**
 * Método encargado de descrifrar la petición realizada a bk.
 * @param {*} response información que se va a descifrar.
 * @returns retorna la información descifrada.
 */
export function decodeData(response) {
    return Jwt.jwtDecode(response.data);
}

/**
 * Método que permite comparar dos objetos.
 * @param {*} valueOne objeto A.
 * @param {*} valueTwo objeto B.
 * @returns retorna true ambos objetos son iguales, en caso contrario se devuelve false.
 */
export function isEquals(valueOne, valueTwo) {
    return valueOne === valueTwo;
}

export function generalSweetAlert(mensaje, tipo) {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,

        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });

    Toast.fire({
        icon: tipo,
        title: mensaje
    });
}

export function alerta() {
    myAlert = Swal.fire({
        imageUrl: imageAlert,
        imageWidth: 1000,
        imageHeight: 700,
        background: "#bccee5",
        // Mismo gradiente de fondo que .login (FullLogin.vue), opaco, en vez del
        // overlay semitransparente por defecto de SweetAlert2: con ese overlay de
        // fábrica, la página que queda detrás (mapa, dashboard, etc.) se sigue viendo
        // si es clara, dando la sensación de que el bloqueo "no cubre" nada.
        backdrop: `radial-gradient(circle at 75% -50%, #00000090 30%, #ffffff00 40%),
            linear-gradient(-40deg, #ff000000, #080c34 60%, #0000ff00),
            radial-gradient(circle at 55% 150%, #3094bc 40%, #00000010 70%),
            radial-gradient(at 0% 0%, #206ca4 5%, #00000000 40%),
            linear-gradient(to bottom, #080c34 0%, #184c7c 100%)`,
        color: "#fff",
        allowEscapeKey: false,
        imageAlt: "Custom image",
        showConfirmButton: false,
        allowOutsideClick: false,
    });
}

export function destruirAlerta() {
    if (myAlert) {
        myAlert.close(); // Cerrar el SweetAlert
    }
}

export async function customizedSweetAlert(message, icon) {
    let response;
    await Swal.fire({
        text: message,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        iconColor: "red",
        reverseButtons: true
    }).then((result) => {
        response = result.isConfirmed;
    });
    return response;
}

//Revisar que se implemente este metodo
export function customizedAlert(title, message, icon, color) {
    Swal.fire({
        title: title,
        text: message,
        icon: icon,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        iconColor: color,
    })
}

export function showLoadingModal(message) {
    Swal.fire({
        title: message,
        html: "Por favor espere...",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
            Swal.showLoading();
        }
    });
}

export function closeLoadingModal() {
    Swal.close();
}

export function normalizeServidor(valor) {
    if (!valor) return valor;

    let dominio = valor.trim();
    dominio = dominio.replace(/^https?:\/\//i, "");
    dominio = dominio.split("/")[0];

    return dominio;
}

/**
 * Separa el dominio del puerto de un valor ya normalizado (sin protocolo ni ruta).
 */
function extraerDominioYPuerto(valorNormalizado) {
    if (!valorNormalizado) return { dominio: "", puerto: null };

    const [dominio, puerto] = valorNormalizado.split(":");

    return {
        dominio: dominio || "",
        puerto: puerto || null,
    };
}

/** Dominio permitido, tomado de VUE_APP_URL (ej. "https://localhost:49173" -> "localhost"). */
function obtenerDominioEsperado() {
    const urlBase = process.env.VUE_APP_URL || "";
    const [, resto] = urlBase.split("://");
    return resto?.split(":")[0] || resto || "";
}

/**
 * Mensaje genérico usado ante cualquier dato de acceso inválido (usuario, contraseña
 * o servidor). Por seguridad no se detalla cuál de los datos falló ni por qué, para
 * no dar pistas a un atacante sobre la configuración real del servidor.
 */
const MENSAJE_CREDENCIALES_INCORRECTAS = "Contraseña o servidor incorrecto";

/**
 * Valida un dominio y puerto ya separados contra los valores permitidos (.env).
 * Es la única fuente de verdad usada tanto por getServidor() como por validarServidor().
 */
function validarDominioYPuerto(dominio, puerto) {
    const dominioEsperado = obtenerDominioEsperado();
    const puertoEsperado = process.env.VUE_APP_PUERTO?.split("'").join("");

    if (!dominio) {
        return { valido: false, mensaje: MENSAJE_CREDENCIALES_INCORRECTAS, puertoEsperado };
    }

    if (dominioEsperado && dominio.toLowerCase() !== dominioEsperado.toLowerCase()) {
        return { valido: false, mensaje: MENSAJE_CREDENCIALES_INCORRECTAS, puertoEsperado };
    }

    if (puerto && puerto !== puertoEsperado) {
        return { valido: false, mensaje: MENSAJE_CREDENCIALES_INCORRECTAS, puertoEsperado };
    }

    return { valido: true, mensaje: "", puertoEsperado };
}

export function getServidor() {
    const servidorGuardado = normalizeServidor(localStorage.getItem("servidor"));
    const { dominio, puerto } = extraerDominioYPuerto(servidorGuardado);
    const { valido, mensaje, puertoEsperado } = validarDominioYPuerto(dominio, puerto);

    if (!valido) {
        console.error(mensaje);
        return "";
    }

    return `https://${dominio}:${puertoEsperado}/asincrona`;
}

/**
 * Valida el valor ingresado en el campo "Servidor" del login, aceptando tanto
 * un hostname simple ("localhost") como una URL completa ("https://localhost:49171/"),
 * y verificando que el protocolo (https), el dominio y el puerto coincidan con los
 * configurados en el .env. Por seguridad, el mensaje de error nunca detalla cuál de
 * esos datos fue el incorrecto: se usa el mismo mensaje genérico que el resto de
 * errores de acceso (usuario/contraseña), para no dar pistas a un atacante.
 * @param {string} valorCrudo valor tal cual lo escribió el usuario.
 * @returns {{ valido: boolean, mensaje: string }} resultado de la validación y,
 * si no es válido, el mensaje genérico de credenciales incorrectas.
 */
export function validarServidor(valorCrudo) {
    if (!valorCrudo?.trim()) {
        return { valido: false, mensaje: "Ingrese el servidor" };
    }

    if (/^http:\/\//i.test(valorCrudo.trim())) {
        return { valido: false, mensaje: MENSAJE_CREDENCIALES_INCORRECTAS };
    }

    const servidorNormalizado = normalizeServidor(valorCrudo);
    const { dominio, puerto } = extraerDominioYPuerto(servidorNormalizado);
    const { valido, mensaje } = validarDominioYPuerto(dominio, puerto);

    return { valido, mensaje };
}
/**
 * Valida únicamente el FORMATO del valor ingresado en el campo "Servidor"
 * (host con caracteres válidos, sin "http://", puerto numérico si se
 * especifica). A diferencia de validarServidor(), NO compara contra el
 * servidor real esperado: se usa solo para habilitar o deshabilitar el envío
 * del formulario, nunca para pintar el campo en verde/rojo mientras se
 * escribe, ya que eso permitiría reconstruir el servidor real probando
 * carácter por carácter. La comparación contra el servidor real ocurre
 * siempre al enviar, con validarServidor().
 * @param {string} valorCrudo valor tal cual lo escribió el usuario.
 * @returns {boolean} true si el formato es válido.
 */
export function tieneFormatoDeServidorValido(valorCrudo) {
    if (!valorCrudo?.trim()) {
        return false;
    }

    const valor = valorCrudo.trim();

    if (/^http:\/\//i.test(valor)) {
        return false;
    }

    const servidorNormalizado = normalizeServidor(valor);
    const { dominio, puerto } = extraerDominioYPuerto(servidorNormalizado);

    const dominioValido = /^[a-zA-Z0-9.-]+$/.test(dominio);
    const puertoValido = puerto === null || /^\d+$/.test(puerto);
    
    return dominioValido && puertoValido;
}

export function getServidorPorAmbiente() {

    // URL base y puerto desde el .env
    const urlBase = process.env.VUE_APP_URL || "";
    const puerto = process.env.VUE_APP_PUERTO?.split("'").join(""); // por si tiene comillas

    // Quitar cualquier puerto que venga en VUE_APP_URL
    const [protocolo, resto] = urlBase.split("://");
    const hostSinPuerto = resto?.split(":")[0] || resto; // Elimina ":puerto" si existe

    // Reconstruir la URL con el puerto deseado
    const urlFinal = `${protocolo}://${hostSinPuerto}:${puerto}/asincrona`;

    return urlFinal;
}